// Generated by tools/actors/build_npc_controller_family_data.mjs.
// Do not hand-edit; values come from original HUMANS CHRM hierarchy node types.
export const NPC_CONTROLLER_FAMILY_BY_MODEL = Object.freeze({
  "AME_L": 10,
  "ASD_L": 7,
  "ASO_L": 10,
  "BAT_L": 10,
  "BAU_L": 10,
  "BCA_L": 4,
  "BGA_L": 0,
  "BGM_L": 10,
  "BIB_L": 0,
  "BUR_L": 10,
  "BWW_L": 19,
  "CHU_L": 7,
  "CMA_L": 10,
  "CT3_M": 16,
  "CT4_M": 16,
  "CT5_M": 16,
  "DG2_M": 18,
  "DG3_M": 18,
  "DOR_L": 0,
  "DRV_L": 0,
  "FKS_L": 19,
  "FLA_L": 0,
  "FLB_L": 0,
  "FLC_L": 0,
  "FLD_L": 0,
  "FLE_L": 0,
  "FLF_L": 0,
  "FLG_L": 0,
  "FLH_L": 0,
  "FLI_L": 0,
  "FLJ_L": 0,
  "FLK_L": 0,
  "FLL_L": 0,
  "FLM_L": 0,
  "FLN_L": 0,
  "FLO_L": 0,
  "FLP_L": 0,
  "FRA_L": 0,
  "FRB_L": 12,
  "FRG_L": 12,
  "FRO_L": 12,
  "FSB_L": 0,
  "FSC_L": 0,
  "FUB_M": 10,
  "FUK_M": 10,
  "FUU_L": 7,
  "FUW_L": 7,
  "GAT_L": 10,
  "GIB_M": 10,
  "GIC_L": 10,
  "GIE_L": 10,
  "GIF_L": 10,
  "GIJ_M": 10,
  "GKA_L": 4,
  "GKB_L": 4,
  "GRL_L": 19,
  "HJB_L": 10,
  "HJW_L": 10,
  "HND_L": 0,
  "HOB_L": 12,
  "HOS_L": 12,
  "HPD_L": 15,
  "HPF_L": 15,
  "HPI_L": 15,
  "HPJ_L": 15,
  "HPX_L": 15,
  "HPY_L": 15,
  "HSA_L": 12,
  "HSB_L": 12,
  "HTR_L": 0,
  "HWB_L": 19,
  "INE_M": 7,
  "JEA_L": 10,
  "JMA_L": 19,
  "JMB_L": 15,
  "JMC_L": 3,
  "JMD_L": 7,
  "JME_": 12,
  "JME_L": 12,
  "JMF_L": 15,
  "JMG_L": 12,
  "JOE_L": 0,
  "JOJ_L": 12,
  "JOJ_M": 12,
  "KAO_L": 12,
  "KAS_L": 7,
  "KEB_L": 0,
  "KHI_L": 7,
  "KHY_L": 12,
  "KIM_L": 10,
  "KIS_M": 10,
  "KJM_L": 10,
  "KMB_L": 10,
  "KMN_L": 0,
  "KOG_L": 7,
  "KOM_L": 4,
  "KOT_L": 7,
  "KRN_L": 15,
  "KTA_L": 4,
  "KUU_L": 0,
  "KVB_L": 0,
  "KVC_L": 0,
  "KVD_L": 0,
  "KVE_L": 0,
  "KVF_L": 0,
  "KVG_L": 0,
  "KVH_L": 0,
  "KVI_L": 0,
  "KVJ_L": 0,
  "KVK_L": 0,
  "KVL_L": 0,
  "KWA_L": 0,
  "KWB_L": 0,
  "KWD_L": 0,
  "KYF_L": 12,
  "KYK_L": 8,
  "KYS_L": 12,
  "KZM_L": 10,
  "MAL_L": 3,
  "MCZ_L": 0,
  "MIB_L": 15,
  "MIH_L": 19,
  "MIR_L": 10,
  "MJA_L": 10,
  "MJB_L": 10,
  "MRU_L": 10,
  "MTK_L": 19,
  "MYT_L": 19,
  "NAN_L": 19,
  "NKK_L": 0,
  "NMR_L": 0,
  "NPB_L": 0,
  "NRS_L": 10,
  "NZM_L": 15,
  "NZM_M": 15,
  "OBA_L": 19,
  "ONL_L": 19,
  "ONO_L": 7,
  "ORI_L": 10,
  "OYA_L": 0,
  "OYB_L": 0,
  "OYC_L": 10,
  "OYD_L": 0,
  "PAN_L": 10,
  "QHB_L": 10,
  "QHT_L": 4,
  "RED_L": 12,
  "RFA_L": 0,
  "RFB_L": 0,
  "RFC_L": 0,
  "RFD_L": 15,
  "RSS_L": 7,
  "SAB_L": 0,
  "SAC_L": 0,
  "SAD_L": 0,
  "SAG_L": 0,
  "SAK_L": 10,
  "SBY_L": 10,
  "SCA_L": 10,
  "SEU_L": 7,
  "SGA_L": 0,
  "SGB_L": 0,
  "SGC_L": 3,
  "SGD_L": 0,
  "SGE_L": 0,
  "SGF_L": 0,
  "SGG_L": 0,
  "SGH_L": 10,
  "SGI_L": 0,
  "SGJ_L": 0,
  "SGK_L": 0,
  "SGL_L": 0,
  "SGM_L": 0,
  "SGN_L": 0,
  "SGO_L": 0,
  "SGP_L": 0,
  "SHA_L": 15,
  "SHB_L": 12,
  "SHE_L": 12,
  "SHX_L": 15,
  "SHY_L": 15,
  "SIA_L": 8,
  "SIB_L": 19,
  "SMK_L": 4,
  "SMT_L": 10,
  "SMY_L": 19,
  "SND_L": 0,
  "SNT_L": 10,
  "SOU_L": 0,
  "SSI_L": 7,
  "SVA_L": 10,
  "SVB_L": 10,
  "TAT_M": 10,
  "THK_L": 4,
  "TJH_L": 4,
  "TKI_L": 7,
  "TOF_L": 7,
  "TOK_L": 10,
  "TOS_L": 10,
  "TPL_L": 10,
  "TPR_L": 10,
  "TTY_L": 8,
  "TUB_L": 7,
  "TUW_L": 10,
  "UBA_L": 0,
  "WAP_L": 7,
  "WDB_L": 12,
  "X32_L": 7,
  "X61_L": 8,
  "X70_L": 10,
  "X72_L": 10,
  "X77_L": 19,
  "YAA_L": 10,
  "YAB_L": 0,
  "YAM_L": 19,
  "YDA_L": 8,
  "YEB_L": 0,
  "YEC_L": 19,
  "YED_L": 19,
  "YEF_L": 7,
  "YGG_L": 7,
  "YHI_L": 0,
  "YKZ_L": 10,
  "YMG_L": 7,
  "YMO_L": 10,
  "YOP_L": 7,
  "YPA_L": 10,
  "YPB_L": 10,
  "YSO_L": 4,
  "YYI_L": 19,
  "ZZA_L": 0,
  "ZZB_L": 0,
  "ZZC_L": 10,
  "ZZE_L": 7
});
